/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_No_RecipeInputs */

const en_import_fail_no_recipe = /** @type {(inputs: Import_Fail_No_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No recipe found in this source`)
};

const de_import_fail_no_recipe = /** @type {(inputs: Import_Fail_No_RecipeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Rezeptangaben in dieser Quelle gefunden`)
};

/**
* | output |
* | --- |
* | "No recipe found in this source" |
*
* @param {Import_Fail_No_RecipeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_no_recipe = /** @type {((inputs?: Import_Fail_No_RecipeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_No_RecipeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_no_recipe(inputs)
	return en_import_fail_no_recipe(inputs)
});